/** @jsxImportSource theme-ui @jsxRuntime classic */
import React, { useMemo } from 'react';
import { Faqs, Flex, Container, AnchorSection } from '@tishman/components';

import { usePageData } from '../utils';

import type { ComponentPropsWithoutRef } from 'react';
import type { Block } from '@sanity/block-content-to-react';

const RinkFaqBlock = (
  props: ComponentPropsWithoutRef<typeof AnchorSection>,
): React.JSX.Element => {
  const { events: sanityAttractionRink } =
    usePageData<Queries.AttractionRinkQuery>();

  const data = useMemo(() => {
    if (!sanityAttractionRink) throw new Error('Expected rink Attraction data');
    if (
      !sanityAttractionRink?._rawFaqs ||
      !Array.isArray(sanityAttractionRink._rawFaqs)
    )
      throw new Error('Expected raw rink faq data');
    if (!sanityAttractionRink?.faqTitle)
      throw new Error('Expected rink faq title');

    return {
      faqs: sanityAttractionRink._rawFaqs,
      title: sanityAttractionRink.faqTitle,
    };
  }, [sanityAttractionRink]);

  return (
    <AnchorSection data-section="RinkFaq" {...props}>
      <Container sx={{ px: [3, 5], pt: [3, 4], pb: 8 }}>
        <Flex
          sx={{
            flexDirection: ['column', null, 'row'],
            justifyContent: 'space-between',
          }}
        >
          <Faqs
            categories={data.faqs}
            faqs={data.faqs as unknown as Block[]}
            title={data.title}
          />
        </Flex>
      </Container>
    </AnchorSection>
  );
};

export default RinkFaqBlock;
